const nfr = {
  i18n404: {
    heading: 'Oops, something went wrong!',
    errorMsgCode: '404',
    errorMsgText: 'File Not Found',
    errorMsg: '404 File Not Found',
    immediateAssitance: 'If you need immediate assistance with anything, please',
    contactUs: 'contact us',
    dot: '.',
    buttonText: 'RETURN TO Home PAGE',
  },
  i18n500: {
    heading: 'Oops, something went wrong!',
    errorMsg: '500 Error Found',
    technicalProblem: 'Sorry, We had some technical problem.',
  },
};
export default nfr;



// WEBPACK FOOTER //
// ./src/locale/nfr-i18n.js